import { skipToken, useInfiniteQuery } from '@tanstack/react-query';

import { Items } from '@air/api';
import {
  type AssetFileKind,
  type ClipAndBoardListItem,
  type ClipAndBoardListOptions,
  type ListResponse,
} from '@air/api/types';

export const ITEMS_LIST_KEY = '@plugin-ui/ITEMS_LIST';

export const getItemsListKey = (params?: UseItemsListParams) => {
  return [ITEMS_LIST_KEY, params];
};

export type UseItemsListParams = ClipAndBoardListOptions & {
  assetTypes?: AssetFileKind[];
  workspaceId: string | undefined;
};

export const ITEMS_LIST_DEFAULT_PARAMS: Partial<UseItemsListParams> = {
  includeAncestors: true,
  includeDirectDescendantCount: true,
  limit: 48,
  numThumbnails: 1,
};

export const useItemsList = (params: UseItemsListParams) => {
  const { assetTypes, ...restParams } = params;
  const assetTypeFilter = assetTypes?.length ? { assetFileKind: { or: assetTypes } } : {};
  const mergedParams = {
    ...ITEMS_LIST_DEFAULT_PARAMS,
    ...restParams,
    filters: {
      ...assetTypeFilter,
      ...restParams.filters,
    },
  };
  const { workspaceId, ...options } = mergedParams;

  return useInfiniteQuery({
    getNextPageParam: (lastPage: ListResponse<ClipAndBoardListItem>) => lastPage?.pagination?.cursor,
    initialPageParam: '',
    queryFn: workspaceId
      ? ({ pageParam }) =>
          Items.searchClipsAndBoards({
            options: {
              ...options,
              cursor: pageParam || null,
            },
            workspaceId,
          })
      : skipToken,
    queryKey: getItemsListKey(mergedParams),
  });
};
